<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<h2 class="h2"><a id="ch00_part1"></a><a id="page_1"><img alt="image" src="images/common1.jpg"/> PART <img alt="image" src="images/common2.jpg"/></a></h2><a id="page_1">
<h2 class="h2"><span class="font">ONE</span></h2>
<p class="textcenter"><strong>What is an adult? A child blown up by age.</strong></p>
<p class="attribution">—<strong>Simone de Beauvoir,</strong> <em>La Femme Rompue</em></p>
</a><p class="image"><a id="page_1"></a><a id="page_2"><img alt="image" src="images/common3.jpg"/></a></p><a id="page_2">
</a></div><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_part1.vue?7baba362